import { React, useState } from 'react';
import './menuCard.css';
import { useNavigate } from 'react-router-dom';
import 'bootstrap';
import Pizza from '../../../assets/images/P1.png';
import CartModal from '../../popup/modifier';
import Modal from 'react-modal';
import AddtoCart from '../cartButton/cartButton';
import { connect } from 'react-redux';
const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

const CostumerMenuCard = ({ val, addToCart, Currency }) => {
  let navigate = useNavigate();

  // const handleATC = () => {
  //     addToCart(val);
  //     navigate('/costumer/menu');
  // };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [CartValue, setCartValue] = useState('');

  const openModal = (e) => {
    setCartValue(e);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const truncatedAddress = val?.name?.length > 20 ? val?.name.substring(0, 20) + '...' : val?.name;
  const truncatedDescription = val?.description?.length > 20 ? val?.description.substring(0, 40) + '...' : val?.description;
  return (
    <>
      <div className="menu-item-card my-5">
        <div className="menu-item-header p-0">
          <div className="tagfont">{val?.discount} % Off</div>
        </div>
        <div className="menu-item-details justify-content-center IMG-BG">
          <div>
            <img src={val?.imageUrl === null || '' ? Pizza : IMAGE_URL + val?.imageUrl} className="item-pic" />
          </div>
        </div>
        <div className="main-color p-lg-3">
          <div className="ItemName" title={val?.name}>
            {truncatedAddress || '--'}
          </div>
          <div className="ItemName" title={val?.stock}>
            {val?.stock || '--'}
          </div>
          <div className="item-des mt-1" title={val?.description}>
            {truncatedDescription || '--'}
          </div>
          <div className="d-flex center gap-3 mt-1">
            {/* <div className="text-decoration-line-through item-price">{Currency.currency.name}  {val?.price}</div> */}
            <div className="item-price ">
              {Currency.currency.code} {val?.price?.toLocaleString('en-US')}
            </div>
          </div>
          <div className="row p-1 mt-3 center">
            {/* <button className="edit-button p-2 w-75" onClick={() => openModal(val)}>
                            Add to cart
                        </button> */}
            <AddtoCart openModal={openModal} val={val} />
          </div>
        </div>
      </div>
      <Modal isOpen={isModalOpen} onRequestClose={closeModal} contentLabel="Cart Modal" value={CartValue}>
        <CartModal CartValue={CartValue} closeModal={closeModal} addToCart={addToCart} />
        {/* <button onClick={closeModal}>Close</button> */}
      </Modal>
    </>
  );
};

const mapStatetoProps = (state) => state;
export default connect(mapStatetoProps)(CostumerMenuCard);
